require('./preleaveCancelModal.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const has = require('lodash/object/has');

//@ commons
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('components/commons/OKButton/OKButton');

//@ core
const { formatText, FormattedText } = require('core/i18n').i18n;

class PreleaveCancelModal extends React.Component {
    buildChildren() {
        if (has(this.props, 'children')) {
            return this.props.children;
        } else {
            return (
                <div className="preleave-cancel-modal__children">
                    <FormattedText
                        className="preleave-cancel-modal__message-title"
                        value="preleaveCancelModal-confirmationTitleMessagePreleave"
                    />
                    <br/>
                    <FormattedText
                        className="preleave-cancel-modal__message"
                        value="preleaveCancelModal-confirmationMessagePreleave"
                    />
                </div>
            );
        }
    }

    buildStayHereButton() {
        const stayHereButtonLabel = has(this.props, 'stayHereButtonLabel') ? this.props.stayHereButtonLabel : formatText('preleaveCancelModal-stayHereButton');

        if (has(this.props, 'onStayHere')) {
            return (
                <div className="col-xs-6 text-left">
                    <OKButton modifier="link-ghost" onClick={this.props.onStayHere}>
                        <span>{stayHereButtonLabel}</span>
                    </OKButton>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        const preleaveCancelModalClassNames = classNames('preleave-cancel-modal', this.props.extraClass);
        const confirmTitle = has(this.props, 'confirmTitle') ? this.props.confirmTitle : formatText('preleaveCancelModal-confirmationTitlePreleave');
        const cancelButtonLabel = has(this.props, 'cancelButtonLabel') ? this.props.cancelButtonLabel : formatText('preleaveCancelModal-cancelButton');
        const colSize = has(this.props, 'onStayHere') ? '6' : '12';
        const onCancelButtonClassNames = classNames(
            'text-right', `col-xs-${colSize}`
        );

        return (
            <ModalCustom
                isOpen={this.props.isOpen}
                extraClass={preleaveCancelModalClassNames}
                shouldCloseOnOverlayClick={false}
                onRequestClose={this.props.onCloseModal}
            >
                <header className="preleave-cancel-modal__header">
                    <span className="preleave-cancel-modal__title">{confirmTitle}</span>
                </header>
                <section className="preleave-cancel-modal__body">
                    {this.buildChildren()}
                </section>
                <footer className="preleave-cancel-modal__footer">
                    <div className="row no-outside-gutter">
                        {this.buildStayHereButton()}
                        <div className={onCancelButtonClassNames}>
                            <OKButton onClick={this.props.onCancel}>
                                <span>{cancelButtonLabel}</span>
                            </OKButton>
                        </div>
                    </div>
                </footer>
            </ModalCustom>
        );
    }
}

PreleaveCancelModal.propTypes = {
    cancelButtonLabel: PropTypes.string,
    children: PropTypes.node,
    confirmTitle: PropTypes.string,
    extraClass: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func,
    onStayHere: PropTypes.func,
    stayHereButtonLabel: PropTypes.string,
};

module.exports = PreleaveCancelModal;
